<ng-container *transloco="let t; read 'home.calculator'">
  <div
    class="flex flex-col md:flex-row gap-10 relative"
    [ngClass]="{'justify-center': !(
    !([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) ||
    (formGroup.controls['site_data_type'] &&
    (formGroup.controls['site_data_type'].value === SiteDataInputType.NREL || formGroup.controls['site_data_type'].value === SiteDataInputType.PVGIS)))}">
    <form
      class="flex flex-col 2xl:w-[35%] md:w-[40%] w-full"
      [formGroup]="formGroup">

      <psc-calculator-country-picker
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-country-picker>

      <psc-calculator-supplier-selector
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-supplier-selector>


      <psc-calculator-tariff-group-selector
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-tariff-group-selector>


      <psc-calculator-consumption-input
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-consumption-input>


      <psc-calculator-site-data-inputs
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-site-data-inputs>

      <psc-calculator-plant-data
        [advanced]="advanced"
        [formGroup]="formGroup"
        [manager]="manager"></psc-calculator-plant-data>


      <psc-input
        @inOutAnimation
        *ngIf="!advanced"
        formControlName="user_contact"
        [label]="t('user_contact.title')"></psc-input>

      <psc-button class="mt-6 mb-4  w-[60%]"
                  [label]="t('submit')"
                  (buttonClicked)="onSubmit()"
                  [disabled]="!formGroup.valid"
                  type="primary-blue-2"></psc-button>

      <div class="text-sm text-gray-500">
        *{{t('long_loading_warning')}}
      </div>
    </form>


    <div class="mt-2 2xl:w-[60%] md:w-[55%] w-full flex-1"
         @inOutFromRight
         *ngIf="!([UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS] | userHasRole) ||
         (formGroup.controls['site_data_type'] &&
          (formGroup.controls['site_data_type'].value === SiteDataInputType.NREL || formGroup.controls['site_data_type'].value === SiteDataInputType.PVGIS))">
      <h6 class="flex items-center">
        {{ t('location') }}<span class="after:content-['*'] after:text-red-700"></span>
        <psc-info-icon [infoText]="t('calculate_area.info')" [sizeInPx]="21"></psc-info-icon>
      </h6>
      <psc-calculator-map
        [orientation]="formGroup.controls['azimuth'] ? formGroup.controls['azimuth'].value : 0"
        (areaSelected)="setAreaValue($event)"
        (locationSet)="setLocation($event)"
        (roofSegmentSelected)="roofSegmentSelected($event)"
        [toggleDrawingMode]="manager.drawingModeActive"></psc-calculator-map>
    </div>

  </div>
</ng-container>
